
const defaults = {
	platform: 'wechat',
	wxReady: false,
	recorderState: 'unchecked',
	startRecordTime: null,
	localId: null,
	recordDuration: 0
};


export default (state=defaults, action) => {
	switch(action.type){
		case 'RECORDER_SET_DURATION': {
			return {...state, recordDuration: action.payload && action.payload.recordDuration}
		}
		case 'RECORDER_START_RECORD':{
			return {...state, 
				recorderState: 'start',
				autoRecordNext: false
			};
		}
		case 'RECORDER_STOP_RECORD':{
			return {...state, 
				recorderState: 'stop',
				autoRecordNext: action.payload && action.payload.autoRecordNext
			};
		}
		case 'RECORDER_CANCEL_RECORD':{
			return {...state, 
				recorderState: 'cancel'
			};
		}
		case 'RECORDER_FORCE_STOP':{
            console.log(action)
			return {...state, 
				recorderState: 'force_stop',
				localId: action.payload.localId
			};
		}
		case 'RECORDER_SET_READY':{
			return {...state, 
				recorderState: 'ready'
			};
		}
		case 'RECORDER_SET_NOT_AVAILABLE': {
			return {...state, 
				recorderState: 'not_available'
			};
		}
		case 'RECORDER_SET_RECORDING':{
			return {...state, 
				recorderState: 'recording', 
				startRecordTime: Date.now(),
				localId: null
			};
		}
		case 'RECORDER_CHECK':{
			return {...state, recorderState: 'check'};
		}
		case 'WECHAT_SET_READY': {
			return {...state, wxReady: true};
		}
		case 'WECHAT_INIT': {
			return {...state, wxReady: false};
		}
		case 'PLATFORM_SET': {
			return {...state, platform: action.payload.platform};
		}
		default:
			return state;
	}
}




// WEBPACK FOOTER //
// ./src/reducers/audioRecorder.js